<markdown ngPreserveWhitespaces>
## Novidades do Sistema a partir de Maio/2022
---
#### Atualizações 21/09/2022
- **SÉRIE DAS BOLETAS**
  - Nomeclatura das opções alinhadas com o time Índigo e formatadas de acordo com Anbima.
- **FUNDOS SEM LIQUIDEZ**
  - Novo Fluxo para boletas com fundos investidos sem liquidez.
- **INTEGRAÇÃO MINICOM - RESGATE TOTAL**
  - Integração Minicom com resgate total.Fluxo de liquidação automática.
- **AJUSTES - BOLETA DE DESPESAS**
  - Integração do cadastro de contrapartes nos "dados do favorecido".
- **BOLETA DE PASSIVO**
  - Alteração na ordem dos componentes da boleta alinhadas com o time Índigo.
  - Integração com Jcot também já foi feita.A boleta pode não ser encaminhada pois o
  cadastro dos gestores no Amplis esté diferente no Jcot.
- **BOLETA ESTRUTURADA - AJUSTE**
  - Ajustes de funcionalidades e etapas da boleta.
- **MERCADO SECUNDÁRIO**
  - Quando selecionado mercado secundário, as liquidações ocorrem em DO.
- **BOLETA DE DESPESAS**
  - Opção de liquidação por "boleto" e quando selecionado esta opção, não há mais obrigação de inserir
  os dados bancáriosdo favorecido.
  - O modal de TED, encontrado na boleta de cotas, agora está na boleta de despesas também.
- **TEMPLATES EXCEL - AJUSTE**
  - Ajuste nos templates do excel para o upload de boletas.
- **BOLETA DE COMPROMISSADA**
  - Novos tipos de liquidação, resgate e resgate total.
- **CADASTRO CONTRAPARTE - AJUSTE**
  - Possibilidade de cadastrar mais de um banco para uma contraparte e também cadastrar
  contrapartes com CPF.
- **ESTOQUE DE ATIVOS**
  - Quando selecionado resgate ou resgate total, aparece um botão para visualizar o 
  estoque do Fundo Investidor. 
  - Ao clicar em algum ativo que o fundo tenha na carteira, os dados 
  do Fundo Investido são preenchidos automaticamente.
- **PAINEL DE PENDÊNCIAS E ATUAÇÕES**
  - Painel de visualização de boletas que necessitam de algum tipo de atuação para seguir o fluxo 
  de liquidação..
- **NOVA IDENTIDADE VISUAL**
  - Personalização do Sistema com base na Identidade Visual da Índigo.
---
#### Atualizações 23/08/2022
- **CONTRAPARTE**
  - Nova funcionalidade: 
    - Contrapartes já cadastradas no banco de dados ou contrapartes com banco 407, seguem o fluxo de
  liquidação automática. 
    - Novas contrapartes ou contrapartes que não são banco 407 seguem fluxo de liquidação manual.
- **MENU SUPERIOR**
  - Novo layout de menu.
- **BOLETA DE DESPESAS**
  - Lista suspensa atualizada com obrigatoriedade de anexo pré-estabelecida para alguns tipos de despesas.
- **CLASSE DOS FUNDOS**
  - Nova funcionalidade:
    - Ao clicar no campo, abre-se uma lista de tipos de classe atrelada ao fundo.
- **INTEGRAÇÃO MINICON - RESGATE PARCIAL**
  - Resgate Parcial Integrado com a Minicom. Boletas de Cota, RF - Título Privado e Margem.
- **QUANTIDADE DE ITENS NA TELA**
  - Nova funcionalidade:
    - Ao escolher a quantidade de operações para aparecer na tela, mesmo quando é página é recarregada, o sistema guarda o número de itens escolhidos 
    anteriormente.
---
#### Atualizações 25/07/2022
- **BOLETAS ESTRUTURADA**
  - Nova Funcionalidade:
    - Permite integrar diversas ordens em uma família de boletas.
- **CONTRAPARTE**
  - Nova funcionalidade:
    - Criar e editar cadastro de contraparte. 
    - Contrapartes já cadastradas no banco de dados, seguem o fluxo automático de liquidação. 
    - Novas contrapartes seguem fluxo para liquidação manual.
- **MENU SUPERIOR**
  - Novo Layout.
- **BOLETA DE DESPESAS**
  - Lista de despesas atualizadas com obrigatoriedade anexo pré-estabelecido para alguns tipos de despesa.
- **CLASSE DAS BOLETAS**
  - Nova funcionalidade:
    - Ao clicar no campo abre-se uma lista de tipos de classe a atrelar ao fundo.
- **QUANTIDADE DE ITENS NA TELA**
  - Nova funcionalidade: 
    - Ao escolher a quantidade de operações para aparecer na tela, mesmo quando a página é recarregada,
  o sistema guarda o número de visualização de operações escolhido anteriormente.
---
#### Atualizações 23/05/2022
- **BOLETAS**
  - Todos os tipos de boletas foram adicionados ao sistema com as funcionalidades básicas para que sejam realizadas as operações.
- **CAMADA**
  - Boletas, fundos internos e fundos externos.
- **Painel do Distribuidor**
  - Boletas, fundos internos, fundos externos, criação e alteração de usuários.
- **BOLETAGEM VIA EXCEL**
  - Boletas, fundos internos e fundos externos.
- **INTEGRAÇÃO MINICOM**
  - Boletas, fundos internos e fundos externos.
- **CARGAS**
  - Boletas, fundos internos e fundos externos, gestores e cotistas.
---
</markdown>